import React from 'react';
import restaurantImg from '../assets/restaurant-preview.jpg';
import salonImg from '../assets/salon-preview.jpg';
import droneImg from '../assets/drone-preview.jpg'; // <-- NEU: Bild importieren

const Portfolio = () => {
  return (
    <section id="portfolio" className="section">
      <div className="container">
        <h2 className="section-title">Ein Einblick in meine <span>Arbeit</span></h2>
        <div className="portfolio-grid">
          
          {/* Projekt 1: Restaurant */}
          <div className="portfolio-item">
            <div className="portfolio-image">
              <a href="https://6897daa8ccd032745c465ae0--restaurantpage1.netlify.app/" target="_blank" rel="noopener noreferrer"><img src={restaurantImg} alt="Restaurant Webseite Vorschau"/></a>
            </div>
            <div>
              <p className="portfolio-tags"><span>Gastronomie</span><span>Elegant</span></p>
              <h3>La Trattoria del Fiume</h3>
              <p>Eine edle Webseite für ein italienisches Restaurant mit Fokus auf Ambiente, Speisekarte und einfacher Reservierungsmöglichkeit.</p>
              <a href="https://6897daa8ccd032745c465ae0--restaurantpage1.netlify.app/" target="_blank" rel="noopener noreferrer" className="cta-secondary">Live-Demo ansehen →</a>
            </div>
          </div>
          
          {/* Projekt 2: Friseursalon */}
          <div className="portfolio-item">
            <div className="portfolio-image">
              <a href="https://6897d60650d5876d74e1476b--friseurpage1.netlify.app/" target="_blank" rel="noopener noreferrer"><img src={salonImg} alt="Friseursalon Webseite Vorschau"/></a>
            </div>
            <div>
              <p className="portfolio-tags"><span>Dienstleistung</span><span>Modern</span><span>Hell</span></p>
              <h3>SALON Élégance</h3>
              <p>Ein schlichtes, aber luxuriöses Design für einen Friseursalon. Der Fokus liegt auf der Präsentation des Teams und der Leistungen.</p>
              <a href="https://6897d60650d5876d74e1476b--friseurpage1.netlify.app/" target="_blank" rel="noopener noreferrer" className="cta-secondary">Live-Demo ansehen →</a>
            </div>
          </div>

          {/* --- NEUES PROJEKT: Drohnen-Vermietung --- */}
          <div className="portfolio-item">
            <div className="portfolio-image">
              <a href="https://6897d5ebc7658b527cfc436c--flowrentpage1.netlify.app/" target="_blank" rel="noopener noreferrer">
                <img src={droneImg} alt="Drohnen-Vermietung Webseite Vorschau"/>
              </a>
            </div>
            <div>
              <p className="portfolio-tags"><span>Vermietung</span><span>Dark-Theme</span><span>Booking</span></p>
              <h3>FlowRent</h3>
              <p>Eine Landing-Page für eine FPV-Drohnenvermietung. Inklusive eines Verfügbarkeitskalenders via Google Calendar und eines angebundenen Kontakt-Backends zur Abwicklung von Anfragen.</p>
              <a href="https://6897d5ebc7658b527cfc436c--flowrentpage1.netlify.app/" target="_blank" rel="noopener noreferrer" className="cta-secondary">Live-Demo ansehen →</a>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default Portfolio;